import { ReactNode } from "react"
import { get } from "lodash"

import * as icons from "components/icons"

export interface ConfigIcon {
  icon_comp?: string
  icon_path?: string
  image?: string
}
export type GetIcon = (config: ConfigIcon) => ReactNode | null

export const getIcon: GetIcon = (config = {}) => {
  const { icon_comp = "", icon_path = null, image = null } = config
  const IconComp = get(icons, icon_comp)

  if (IconComp) return <IconComp />

  if (icon_path) return <icons.CustomIcon path={icon_path} />

  if (image) return <icons.CustomImageIcon src={image} />

  return null
}
